"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSwitcher = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var ImageSwitcher = function (_a) {
    var images = _a.images, _b = _a.isDesktop, isDesktop = _b === void 0 ? true : _b, theme = _a.theme;
    // Common state structure for both desktop and mobile
    var initState = {
        currLayer: "layer1",
        layer1: isDesktop ? [0, 1] : [0],
        layer2: isDesktop ? [2, 3] : [1],
    };
    var _c = (0, react_1.useState)(initState), coverImageIdx = _c[0], setCoverImageIdx = _c[1];
    // Reset state when desktop/mobile mode changes
    (0, react_1.useEffect)(function () {
        setCoverImageIdx(initState);
    }, [isDesktop]);
    (0, react_1.useEffect)(function () {
        var interval, timeout;
        var minImages = isDesktop ? 4 : 2;
        if (images.length >= minImages) {
            interval = setInterval(function () {
                setCoverImageIdx(function (prev) { return (__assign(__assign({}, prev), { currLayer: prev.currLayer === "layer1" ? "layer2" : "layer1" })); });
                timeout = setTimeout(function () {
                    setCoverImageIdx(function (prev) {
                        var _a;
                        var layerToSwitch = prev.currLayer === "layer1" ? "layer2" : "layer1";
                        var increment = isDesktop ? 4 : 2;
                        return __assign(__assign({}, prev), (_a = {}, _a[layerToSwitch] = prev[layerToSwitch].map(function (idx) { return (idx + increment) % images.length; }), _a));
                    });
                }, 800); // Match transition duration
            }, 3000);
        }
        return function () {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [isDesktop, images.length]);
    if (isDesktop) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styled_1.ImageWrapper, null,
                react_1.default.createElement(styled_1.StyledContentWrapper, { "$backgroundImage": images[coverImageIdx.layer1[0]], "$opacity": coverImageIdx.currLayer === "layer1" ? 1 : 0, theme: theme }),
                react_1.default.createElement(styled_1.StyledContentWrapper, { "$backgroundImage": images[coverImageIdx.layer2[0]], "$opacity": coverImageIdx.currLayer === "layer2" ? 1 : 0, theme: theme })),
            react_1.default.createElement(styled_1.ImageWrapper, null,
                react_1.default.createElement(styled_1.StyledContentWrapper, { "$backgroundImage": images[coverImageIdx.layer1[1]], "$opacity": coverImageIdx.currLayer === "layer1" ? 1 : 0, theme: theme }),
                react_1.default.createElement(styled_1.StyledContentWrapper, { "$backgroundImage": images[coverImageIdx.layer2[1]], "$opacity": coverImageIdx.currLayer === "layer2" ? 1 : 0, theme: theme }))));
    }
    // Mobile render - single image with opacity transition
    return (react_1.default.createElement(styled_1.MobileWrapper, null,
        react_1.default.createElement(styled_1.StyledContentWrapper, { "$backgroundImage": images[coverImageIdx.layer1[0]], "$opacity": coverImageIdx.currLayer === "layer1" ? 1 : 0, className: "mobile" }),
        react_1.default.createElement(styled_1.StyledContentWrapper, { "$backgroundImage": images[coverImageIdx.layer2[0]], "$opacity": coverImageIdx.currLayer === "layer2" ? 1 : 0, className: "mobile" })));
};
exports.ImageSwitcher = ImageSwitcher;
